import { Box } from "@repo/components/src/ui/box";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import React from "react";

const Row = React.memo((props: { name: string; value: string }) => {
  return (
    <Box>
      <Box className="w-full border-[0.5px] my-3 border-typography-600" />
      <HStack space="sm" className="items-start justify-between">
        <Text size="sm" className="flex-1 shrink">
          {props.name}
        </Text>
        <Text size="sm">{props.value}</Text>
      </HStack>
    </Box>
  );
});

Row.displayName = "Row";

export default Row;
